<template>
  <div>
    <div v-if="show" style="position: fixed;width: 100%;height: 100%;z-index: 999;opacity: 1;background-color: #fff;">
      <div style="text-align: center;margin-top: 60px;">
        <img src="@/assets/pdf/hawkeye.jpg" style="width: 180px;height: 180px;">
        <div class="indexInfoDiv">
          <div style="font-size: 30px;margin-top: 15px;">弈客鹰眼5.0智能棋评</div>
          <div style="margin-top: 40px;font-size: 15px;line-height: 26px;">
            <div v-if="colorIndex>=0" style="font-size: 45px;" :style="{'color': colorList[colorIndex]}">{{ desc }}
            </div>
            <div v-else>{{ desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="btnList">
        <span class="btn" @click="last">上一页</span>
        <span class="btn" @click="topdf">下载PDF</span>
        <span class="btn" @click="next">下一页</span>
      </div>
      <div id="content">
        <div class="pdfDom">
          <div v-if="show" class="pdfPage" style="background-color:#300323 ;">

          </div>
          <div id="pdfPage1" class="pdfPage">
            <reportLogo></reportLogo>
            <div style="text-align: center;padding-top: 40px;">
              <img src="@/assets/pdf/hawkeye.jpg" style="width: 200px;height: 200px;">
            </div>
            <div class="indexInfoDiv">
              <div style="font-size: 50px;margin-top: 30px;">{{ result.title }}</div>
              <div style="margin-top: 60px;font-size: 15px;line-height: 50px;font-size: 25px;">
                <div>{{ result.name }}</div>
                <div>{{ result.player }}</div>
                <div>{{ result.result }}</div>
              </div>
            </div>
            <div style="position: absolute;bottom: 40px;width:100%">
              <div style="display: flex;width: 90%;margin: auto;justify-content: space-between;align-items: flex-end;">
                <div style="font-size: 20px;">
                  <div v-if="teacher">老师：{{teacher}}</div>
                  <div>{{ result.rule }}</div>
                  <div>对局日期 {{ result.game_date }}</div>
                  <div>报告日期 {{ result.create_date }}</div>
                  <div @click="goreport" style="margin-top: 20px;">鹰眼报告网页版</div>
                  <div>软件与权重：KataGo / G170 2020.02</div>
                </div>
                <div class="qrcode" ref="qrCodeUrl"></div>
              </div>
            </div>
          </div>
          <div id="pdfPage2" class="pdfPage">
            <reportLogo></reportLogo>
            <div style="padding:0px 8% ;box-sizing: border-box;">
              <div class="fenpuTitle">目录</div>
              <div class="menuDiv">
                <template v-for="(item,index) in page" v-bind:key="index">
                  <div v-if="item.main" class="menu">
                    <div style="display: flex;width:100%;font-size: 20px;">
                      <div style="padding: 0 10px;width: 50px;">•</div>
                      <div style="flex-grow:1;">{{ item.name }}</div>
                      <div style="display: flex;align-items: center;justify-content: center;flex-grow:10;">
                        <div style="border-top: 1px dashed #808080;height: 1px;width: 100%">
                        </div>
                      </div>
                      <div style="width: 15px;text-align: right;flex-grow:1;">{{ index + 1 }}</div>
                    </div>
                  </div>
                </template>
                <template v-for="(item,index) in addmenu" v-bind:key="index">
                  <div class="menu">
                    <div style="display: flex;width:100%;font-size: 20px;">
                      <div style="padding: 0 10px;width: 50px;">•</div>
                      <div style="flex-grow:1;">{{ item }}</div>
                      <div style="display: flex;align-items: center;justify-content: center;flex-grow:10;">
                        <div style="border-top: 1px dashed #808080;height: 1px;width: 100%">
                        </div>
                      </div>
                      <div style="width: 15px;text-align: right;flex-grow:1;">{{ page.length + index+1 }}</div>
                    </div>
                  </div>
                </template>
              </div>
              <!-- <div style="position: absolute;bottom: 20px;width: 80%;">
                <div style="font-size: 22px;font-weight: bold;">使用说明</div>
                <div style="font-size: 18px;margin-top: 5px;font-weight: bold;">① 走势图</div>
                <div style="font-size: 14px;line-height: 25px;color: #4c4c4c;">
                  <div>由胜率与目差两部分组成，反映了棋局优劣走势。</div>
                  <div>胜率为黑棋视角。</div>
                  <div>目差为正代表黑棋实地领先，目差为负代表白棋实地领先。</div>
                </div>

                <div style="font-size: 18px;margin-top: 5px;font-weight: bold;">② 吻合度</div>
                <div style="font-size: 14px;line-height: 25px;color: #4c4c4c;">
                  <div>用户首选点命中AI选点的比例。</div>
                </div>
              </div> -->
            </div>
          </div>
          <template v-for="(item,index) in page" v-bind:key="index">
            <div :id="'pdfPage'+(parseInt(index)+3)" class="pdfPage">
              <reportLogo></reportLogo>
              <div class="fenpuTitle">{{ item.name }}</div>
              <template v-if="item.items.length==1">
                <div style="width:70%;padding-top: 10px;margin: auto;">
                  <board :cap_list="item.cap_list" :show_move="item.items[0].show_move" :id="'board-'+index" :sgf="item.items[0].sgf"
                    :desc="item.items[0].comment">
                  </board>
                </div>
              </template>
              <template v-else>
                <div class="box">
                  <div v-bind:key="'sgf'+idx" v-for="(sgf,idx) in item.items" class="column">
                    <board :show_move="sgf.show_move" :id="index+'-'+idx" class="eboard" :sgf="sgf.sgf" fontsize="16"
                      :is_scale="true" margintop="10" :desc="sgf.comment"></board>
                  </div>
                </div>
              </template>
              <footerCom v-if="institution" :page="index+1" :title="institution"></footerCom>
              <footerCom v-else :page="index+1"></footerCom>
            </div>
          </template>
          <div :id="'pdfPage'+(parseInt(page.length)+3)" class="pdfPage">
            <reportLogo></reportLogo>
            <div class="fenpuTitle" >鹰眼评分</div>
            <div class="chartScoreDiv">黑棋评分：{{bAllScore}} 白棋评分：{{wAllScore}}</div>
            <div class="chartTitle">黑棋评分</div>
            <div style="width: 100%;height: 300px;" id="scoreChartB"></div>
            <div class="chartTitle">白棋评分</div>
            <div style="width: 100%;height: 300px;" id="scoreChartW"></div>
            <table  style="width: 60%;margin: 20px 80px;margin-bottom: 20px;border-color: #808088;margin-top: 20px;" border="1" cellspacing="0" cellpadding="0">
              <tr> <td>鹰眼评分</td>  <td>发挥水准</td></tr>
              <tr> <td>0~10</td> <td>入门</td> </tr>
              <tr> <td>10~20</td> <td>业余低级</td> </tr>
              <tr> <td>20~30</td> <td>业余高级</td> </tr>
              <tr> <td>30~40</td> <td>业余低段</td> </tr>
              <tr> <td>40~50</td> <td>业余5段</td> </tr>
              <tr> <td>50~60</td> <td>职业棋手/业余豪强</td> </tr>
              <tr> <td>60~70</td> <td>顶尖棋手</td> </tr>
              <tr> <td>70~75</td> <td>人类巅峰</td> </tr>
              <tr> <td>75~100</td> <td>围棋AI</td> </tr>
            </table>
            <div class="chartDesc">
              <div> ① 胜率为黑棋视角，反映了一局棋的优劣走势；</div>
              <div> ② 胜率超过50%为黑棋优势，胜率低于50%为白棋优势。</div>
             </div>
          </div>

          <div :id="'pdfPage'+(parseInt(page.length)+4)" class="pdfPage">
            <reportLogo></reportLogo>
            <div class="fenpuTitle" >鹰眼吻合度</div>
            <div class="chartTitle">首选点模式</div>
            <div style="width: 100%;height: 400px;" id="hitHandMain"></div>
            <div class="chartDesc">
              <div> ①  首选点吻合度指用户命中AI首选点的比例，图中粗竖线代表命中的手数。</div>
            </div>
            <div class="chartTitle" style="margin-top: 30px;">推荐点模式</div>
            <div style="width: 100%;height: 400px;" id="hitHandBranch"></div>
            <div class="chartDesc">
              <div> ①  推荐点吻合度指用户命中AI任意推荐点（含首选点）的比例，图中粗竖线代表命中的手数。</div>
            </div>
          </div>

          <div :id="'pdfPage'+(parseInt(page.length)+5)" class="pdfPage">
            <reportLogo></reportLogo>
            <div class="fenpuTitle" >棋局走势</div>
            <div class="chartTitle">棋局走势(胜率)</div>
            <div style="width: 100%;height: 400px;" id="chartTrendRate"></div>
            <div class="chartDesc">
             <div> ① 胜率为黑棋视角，反映了一局棋的优劣走势；</div>
             <div> ② 胜率超过50%为黑棋优势，胜率低于50%为白棋优势。</div>
            </div>
            <div class="chartTitle" style="margin-top: 30px;">棋局走势(目差)</div>
            <div style="width: 100%;height: 400px;" id="chartTrendAn"></div>
            <div class="chartDesc">
              <div> ① 目差已经扣除了贴目；</div>
              <div> ② 目差为正代表黑棋实地领先，为负代表白棋实地领先。</div>
             </div>
          </div>
          <!-- <div :id="'pdfPage'+(parseInt(page.length)+5)" class="pdfPage">
            <div style="text-align: center;padding-top: 200px;font-size: 16px;font-weight: bold;">
              <img src="@/assets/pdf/erweima.jpeg" style="width: 150px;height: 150px;">
              <div style="margin-top: 40px;font-size: 25px;">线上社群 · SAAS服务 · 智能制造</div>
              <div style="margin-top: 20px;font-size: 25px;">围棋产业互联网</div>

              <div style="margin-top: 40px;font-size: 18px;text-decoration: underline;">国家级体育示范项目</div>
            </div>
            <div
                style="position: absolute;text-align: center;width: 100%;bottom: 30px;color: #808080;font-size: 12px;">
              上海弈客信息技术有限公司
            </div>
          </div> -->
        </div>
      </div>

      <div v-html="pageData"></div>
    </div>
  </div>
</template>

<script>
  document.querySelector('html').setAttribute('style', 'background-color:#300323')
  let pdf = null;
  import { pdfData } from '@/request/api'
  import * as echarts from 'echarts';
  import html2Canvas from 'html2canvas'
  import JsPDF from 'jspdf'
  import QRCode from 'qrcodejs2'

  export default {
    data() {
      return {
        addmenu: ["鹰眼评分","鹰眼吻合度", "棋局走势"],
        pageData: null,  //接收html格式代码
        pdfTitle: "鹰眼报告",
        isTest: true,
        result: {},
        moves: [],
        allPath: 0,
        minHand: 0,
        maxHand: 0,
        aiSize: 0,
        style: {
          color: "",
          trendTop: 0,
          fontsize: 0,
          legendTop: "",
        },
        isKm: false,
        reportType: 0,
        page: [],
        show: true,
        desc: "正在加载数据",
        pdfImgArr: [],
        pageCount: 0,
        imgWidth: 0,
        imgHeight: 0,
        colorList: [
          "rgba(36, 142, 53,1)",
          "rgba(36, 142, 53,1)",
          "rgba(36, 142, 53,1)",
          "#82AA28",
          "#DCB41E",
          "#EB8C00",
          "#DC5A14",
          "#EB0000",
          "#DC0000",
        ],
        colorIndex: -1,
        teacher: "",
        institution: "",
        bAllScore: 0,
        wAllScore: 0,
      }
    },
    created() {
      this.token = this.getQueryVariable('token')
      this.teacher = this.getQueryVariable('teacher')
      this.institution = this.getQueryVariable('institution')
      this.style.color = "#4c4c4c"
      this.style.trendTop = '15%';
      this.style.fontsize = 14;
      this.style.legendTop = "10";
      this.style.trendgrid = {
        left: '13%',
        right: '13%',
        top: "15%",
        bottom: '15%',
      }
      this.style.badhandgrid = {
        left: '13%',
        right: '10%',
        top: "13%",
        bottom: '15%',
      }
      this.style.hithandgrid = {
        left: '13%',
        right: '13%',
        top: "12%",
        bottom: '15%',
      }
      this.style.scoregrid = {
        left: '13%',
        right: '13%',
        top: '15%',
        bottom: '15%',
      }
      this.style.bandYshow = true;
    },
    mounted() {
      pdf = new JsPDF('', 'pt', 'a4')
      this.echartsHeight = 400
      this.$nextTick(() => {
        this.creatQrCode()
        this.initData()
      })
    },
    methods: {
      getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return decodeURI(pair[1]);
          }
        }
        return (false);
      },
      creatQrCode() {
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: window.location.href.split('#')[0], // 需要转换为二维码的内容
          width: 100,
          height: 100,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
      initData() {
        pdfData(this.token).then(result => {
          var res = result.data
          this.page = res.sgfs
          this.pageCount = this.page.length + 5
          this.result = res
          this.moves = res.hands
          this.allPath = res.hands_count
          this.maxHand = res.hands_count
          this.aiSize = 1750 / res.hands_count - 1
          this.intiChart()
          this.show = false
        })
      },

      intiChart() {
        this.inidDom()
        this.loadTrendRate()
        this.loadTrendAn()
        this.loadScoreChart()
        // this.loadBadHand()
        this.loadhitHandMain()
        this.loadhitHandBranch()
      },
      //初始化图表
      inidDom() {
        // 棋局走势(胜率)
        this.chartTrendRate = echarts.init(document.getElementById('chartTrendRate'));
        // 棋局走势(目差)
        this.chartTrendAn = echarts.init(document.getElementById('chartTrendAn'));
        // 黑棋评分
        this.scoreChartB = echarts.init(document.getElementById('scoreChartB'));
        // 白棋评分
        this.scoreChartW = echarts.init(document.getElementById('scoreChartW'));
        // 恶手
        // this.badHand = echarts.init(document.getElementById('badHand'));
        // 吻合度
        this.hitHandMain = echarts.init(document.getElementById('hitHandMain'));
       // 吻合度
        this.hitHandBranch = echarts.init(document.getElementById('hitHandBranch'));
        
      },
      //加载棋局走势胜率
      loadTrendRate() {
        let move = [],
          wr = [],
          an = [],
          max = 0;
        for (let i = 0; i < this.allPath - 1; i++) {
          const hand = this.moves[i];
          if (Math.abs(hand.an_result) > max) {
            max = Math.abs(hand.an_result);
          }
          move.push(hand.move);
          wr.push(hand.b_rate);
          an.push(hand.an_result)
        }
        var interval = move.length / 6
        let option = {
          grid: this.style.trendgrid,
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#f86747',
            },
          },
          graphic: [{
            type: 'text',
            id: 'desc',
            right: 'center',
            top: 40,
            z: -10,
            bounding: 'raw',
            origin: [75, 75],
          },],
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: move,
            axisLabel: {
              interval: parseInt(interval) //间隔
            },
            nameTextStyle: {
              color: this.style.color
            },
            max: this.allPath,
            axisLine: {
              lineStyle: {
                color: this.style.color
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true
            },
          },
          yAxis: [{
            name: '(%)',
            type: 'value',
            max: 100,
            min: 0,
            splitNumber: 2,
            boundaryGap: false,
            nameTextStyle: {
              color: this.style.color
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.style.color
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: this.style.color,
                width: 0.5
              }
            },
          }
          ],
          series: [
            {
              name: '黑胜率',
              type: 'line',
              data: wr,
              symbolSize: 0,
              symbol: "none",
              itemStyle: {
                normal: {
                  barBorderRadius: 30,
                  color: '#000000'
                }
              },
              z: 2,
              smooth: true,
            }
          ]
        };
        this.chartTrendRate.setOption(option);
      },
      //加载棋局走势目差
      loadTrendAn() {
        let move = [],
          wr = [],
          an = [],
          max = 0;
        for (let i = 0; i < this.allPath - 1; i++) {
          const hand = this.moves[i];
          if (Math.abs(hand.an_result) > max) {
            max = Math.abs(hand.an_result);
          }
          move.push(hand.move);
          wr.push(hand.b_rate);
          an.push(hand.an_result)
        }
        var interval = move.length / 6
        let option = {
          grid: this.style.trendgrid,
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#f86747',
            },
          },
          graphic: [{
            type: 'text',
            id: 'desc',
            right: 'center',
            top: 40,
            z: -10,
            bounding: 'raw',
            origin: [75, 75],
          },],
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: move,
            axisLabel: {
              interval: parseInt(interval) //间隔
            },
            nameTextStyle: {
              color: this.style.color
            },
            max: this.allPath,
            axisLine: {
              lineStyle: {
                color: this.style.color
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true
            },
          },
          yAxis: [{
            name: '(目)',
            type: 'value',
            splitNumber: 1,
            max: Math.round(max),
            min: -Math.round(max),
            boundaryGap: false,
            nameTextStyle: {
              color: this.style.color
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.style.color
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: this.style.color,
                width: 0.5
              }
            },
          }
          ],
          series: [{
            yAxisIndex: 0,
            name: '目差',
            type: 'line',
            data: an,
            symbolSize: 0,
            symbol: "none",
            itemStyle: {
              normal: {
                barBorderRadius: 30,
                color: '#808080'
              }
            },
            smooth: true,
            z: 1,
          },
          ]
        };
        this.chartTrendAn.setOption(option);
      },
      //加载恶手分析
      loadBadHand() {
        var _this = this;
        var dataarr = [],
          color = 0;
        if (this.playerType == 0) {
          color = 0
        } else if (this.playerType == 1) {
          color = -1
        } else if (this.playerType == 2) {
          color = 1
        }
        for (let i = 1; i < this.allPath; i++) {
          var item = this.result.hands[i]
          if (item.level >= 5 && item.color != color && item.move > this.minHand && item.move <= this.maxHand) {
            dataarr.push(item)
          }
        }
        dataarr = dataarr.sort((a, b) => {
          return a.bad_sort - b.bad_sort
        })
        dataarr = dataarr.slice(0, 10)
        dataarr.sort((a, b) => {
          return a.move - b.move
        })
        let hands = [], series = [];
        for (let i = 0; i < dataarr.length; i++) {
          let item = dataarr[i]
          hands.push(item.move)
          series.push([i, item.cur_rate.toFixed(1), item.pre_rate.toFixed(1), item.color, item.an_diff.toFixed(1), "", item.move, item.rate_diff.toFixed(0)])
        }

        this.style.axisTick = {
          length: 2,
          inside: true,
          alignWithLabel: true,
          lineStyle: {
            color: this.style.color,
            width: 0.5
          }
        }

        let option = {
          grid: this.style.badhandgrid,
          legend: {
            textStyle: {
              fontSize: this.style.fontsize
            }
          },
          xAxis: {
            axisLine: { //坐标轴轴线
              lineStyle: {
                color: this.style.color
              },
            },
            data: hands,
            axisTick: this.style.axisTick,
            axisLabel: {
              show: true,
              textStyle: {
                fontSize: () => {
                  if (this.platform == "mobile") {
                    return 10
                  } else {
                    return 14
                  }
                },
              }
            },


            boundaryGap: true
          },
          yAxis: {
            show: this.style.bandYshow,
            type: 'value',
            min: 0,
            max: 100,
            splitNumber: 2,
            boundaryGap: false,
            nameTextStyle: {
              color: this.style.color,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: this.style.color,
              }
            },
            splitLine: {
              show: false,
            }
          },
          series: [{
            symbol: (value, params) => {
              var stone = _this.result.hands[value[6]]
              if (stone.color == 1) {
                return 'image://' + require('@/assets/face/mw' + stone.level + '.png')
              } else {
                return 'image://' + require('@/assets/face/mb' + stone.level + '.png')
              }
            },
            label: {
              show: true,
              position: "insideBottom",
              distance: 8, // 正 上移 
              textStyle: {
                color: '#f7f7f7',
                fontWeight: '600',
                fontSize: 10
              },
              formatter: function (data) {
                return '↓' + Math.abs(data.data[7]);
              }
            },
            symbolSize: () => {
              return [27, 135]
            },
            symbolOffset: [0, '-75'],
            data: series,
            type: 'scatter',
          }]
        };
        this.badHand.setOption(option);
      },
      //加载吻合度
      loadhitHandMain() {
        let bArr = [], wArr = [], b = 0, w = 0;
        for (let i = 1; i <= this.allPath; i++) {
          if (i >= this.minHand && i <= this.maxHand) {
            var item = this.result.hands[i]
            var flag = item.main_hit;
            if (item.color == 1) {
              if (flag) b++
              bArr.push([i, 4, flag]);
              wArr.push([i, 2, false]);
            } else {
              if (flag) w++
              bArr.push([i, 4, false]);
              wArr.push([i, 2, flag]);
            }
          }
        }
       var bw = (b / (bArr.length / 2) * 100).toFixed(1) + "%"
       var ww = (w / (wArr.length / 2) * 100).toFixed(1) + "%"

        let option = {
          grid: this.style.hithandgrid,
          legend: {
            top: this.style.legendTop,
            data: ['黑棋', '白棋'],
            formatter: function (name) {
              if (name == "黑棋") {
                if (this.platform == "mobile") {
                  return "黑吻合:" + bw
                } else {
                  return "黑棋吻合度：" + bw
                }
              } else {
                if (this.platform == "mobile") {
                  return "白吻合:" + ww
                } else {
                  return "白棋吻合度：" + ww
                }
              }
            }.bind(this),
            selectedMode: false,
            textStyle: {
              color: this.style.color,
              fontSize: this.style.fontsize
            },
          },
          xAxis: {
            min: this.minHand,
            max: this.maxHand,
            splitLine: {
              show: true
            },
            axisLine: {
              show: true,
              lineStyle: { color: this.style.color, }
            },
            axisLabel: {
              show: true,
              Color: this.style.color
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            max: 5,
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: { color: this.style.color, }
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              formatter: function (value) {
                if (value == 4) {
                  return "{a|黑棋}"
                } else if (value == 2) {
                  return "{a|白棋}"
                }
              },
              rich: {
                a: {
                  color: this.style.color,
                },
              }
            }
          },
          series: [
            {
              emphasis: {
                focus: 'self',
                blurScope: 'global'
              },
              name: "黑棋",
              symbol: 'roundRect',
              symbolSize: function (data) {
                if (data[2] == false) {
                  return 1
                } else {
                  return [4, 20]
                }
              }.bind(this),
              data: bArr,
              type: 'scatter',
              itemStyle: {
                color: "#000000"
              },
            }, {
              emphasis: {
                focus: 'self',
                blurScope: 'global'
              },
              name: "白棋",
              symbol: 'roundRect',
              symbolSize: function (data) {
                if (data[2] == false) {
                  return 1
                } else {
                  return [4, 20]
                }
              }.bind(this),
              data: wArr,
              type: 'scatter',
              itemStyle: {
                color: "#808080"
              }
            }]
        };
        this.hitHandMain.setOption(option)
      },


      loadhitHandBranch(){
        let bArr = [], wArr = [], b = 0, w = 0;
        for (let i = 1; i <= this.allPath; i++) {
          if (i >= this.minHand && i <= this.maxHand) {
            var item = this.result.hands[i]
            var flag = item.branch_hit;
            if (item.color == 1) {
              if (flag) b++
              bArr.push([i, 4, flag]);
              wArr.push([i, 2, false]);
            } else {
              if (flag) w++
              bArr.push([i, 4, false]);
              wArr.push([i, 2, flag]);
            }
          }
        }
        var bw = (b / (bArr.length / 2) * 100).toFixed(1) + "%"
        var ww = (w / (wArr.length / 2) * 100).toFixed(1) + "%"

        let option = {
          grid: this.style.hithandgrid,
          legend: {
            top: this.style.legendTop,
            data: ['黑棋', '白棋'],
            formatter: function (name) {
              if (name == "黑棋") {
                if (this.platform == "mobile") {
                  return "黑吻合:" + bw
                } else {
                  return "黑棋吻合度：" +bw
                }
              } else {
                if (this.platform == "mobile") {
                  return "白吻合:" + ww
                } else {
                  return "白棋吻合度：" + ww
                }
              }
            }.bind(this),
            selectedMode: false,
            textStyle: {
              color: this.style.color,
              fontSize: this.style.fontsize
            },
          },
          xAxis: {
            min: this.minHand,
            max: this.maxHand,
            splitLine: {
              show: true
            },
            axisLine: {
              show: true,
              lineStyle: { color: this.style.color, }
            },
            axisLabel: {
              show: true,
              Color: this.style.color
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            max: 5,
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: { color: this.style.color, }
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              formatter: function (value) {
                if (value == 4) {
                  return "{a|黑棋}"
                } else if (value == 2) {
                  return "{a|白棋}"
                }
              },
              rich: {
                a: {
                  color: this.style.color,
                },
              }
            }
          },
          series: [
            {
              emphasis: {
                focus: 'self',
                blurScope: 'global'
              },
              name: "黑棋",
              symbol: 'roundRect',
              symbolSize: function (data) {
                if (data[2] == false) {
                  return 1
                } else {
                  return [4, 20]
                }
              }.bind(this),
              data: bArr,
              type: 'scatter',
              itemStyle: {
                color: "#000000"
              },
            }, {
              emphasis: {
                focus: 'self',
                blurScope: 'global'
              },
              name: "白棋",
              symbol: 'roundRect',
              symbolSize: function (data) {
                if (data[2] == false) {
                  return 1
                } else {
                  return [4, 20]
                }
              }.bind(this),
              data: wArr,
              type: 'scatter',
              itemStyle: {
                color: "#808080"
              }
            }]
        };
        this.hitHandBranch.setOption(option)
      },
      // 加载评分
      loadScoreChart() {
        let barr = [], warr = [];
        let handCount = 0;
        for (var i = 1; i < this.allPath; i++) {
          if (i >= this.minHand && i <= this.maxHand) {
            handCount++
            if (this.moves[i].color == 1) {
              let score = 0;
              for (var j = this.minHand; j <= i; j++) {
                if (this.moves[j].color == 1) {
                  score += this.moves[j].score
                }
              }
              barr.push([i, score / (parseInt((handCount + 1) / 2))])
            }
            if (this.moves[i].color == -1) {
              let score = 0;
              for (var j = this.minHand; j <= i; j++) {
                if (this.moves[j].color == -1) {
                  score += this.moves[j].score
                }
              }
              warr.push([i, score / (parseInt((handCount + 1) / 2))])
            }
          }
        }

        if (warr.length > 0) {
          this.wAllScore = warr[warr.length - 1][1].toFixed(1)
        }
        if (barr.length > 0) {
          this.bAllScore = barr[barr.length - 1][1].toFixed(1)
        }
        var option = {
          grid: this.style.scoregrid,
          xAxis: {
            type: 'value',
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: { color: this.style.color, }
            },
            axisTick: {
              show: false,
            },
            min: this.minHand,
            max: this.maxHand,
          },
          yAxis: {
            min: 0,
            max: 100,
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: "#a9a6ae",
                width: 0.5
              }
            },
            axisLine: {
              show: true,
              lineStyle: { color: this.style.color, }
            },
            axisTick: {
              show: false,
            },
          },
        };
        let optionb=option
        optionb.series = [{
          name: "黑棋评分",
          data: barr,
          type: 'line',
          smooth: true,
          showSymbol: false,
          itemStyle: {
            color: "#000000"
          }
        }]
        this.scoreChartB.setOption(optionb);
        let optionw=option
        optionw.series = [{
          name: "白棋评分",
          data: warr,
          type: 'line',
          smooth: true,
          showSymbol: false,
          itemStyle: {
            color: "#808080"
          }
        }]
        this.scoreChartW.setOption(optionw);
      },
      topdf() {
        this.desc = "0%"
        this.show = true
        this.colorIndex = 0
        setTimeout(() => {
          this.createPdf(1)
        }, 500);

      },
      createPdf(j) {
        var _this = this
        if (j > this.pageCount) {
          pdf.save(_this.result.title + "-" + _this.result.name + '.pdf')
          this.show = false
          this.desc = "正在加载数据"
          this.colorIndex = -1
          return
        }
        _this.colorIndex = parseInt(Math.random() * 8)
        _this.desc = (j / this.pageCount * 100).toFixed(1) + "%"
        var dom = '#pdfPage' + j
        var c = document.createElement("canvas")
        var opts = {
          scale: 2,
          canvas: c,
          width: document.querySelector(dom).offsetWidth,
          height: document.querySelector(dom).offsetHeight,
          allowTaint: true,
          scrollX: 0,
          scrollY: -window.pageYOffset,
          useCORS: true,
        };
        c.width = document.querySelector(dom).offsetWidth * 2
        c.height = document.querySelector(dom).offsetHeight * 2
        c.getContext("2d").scale(1, 1);
        html2Canvas(document.querySelector(dom), opts).then(function (canvas) {
          let contentWidth = canvas.width
          let contentHeight = canvas.height
          let pageHeight = contentWidth / 592.28 * 841.89
          let leftHeight = contentHeight
          _this.imgWidth = 595.28
          _this.imgHeight = 592.28 / contentWidth * contentHeight
          let pageData = canvas.toDataURL('image/jpeg', 1)
          // _this.pdfImgArr.push({page:j,img:pageData})
          // console.log( _this.pdfImgArr)
          pdf.addImage(pageData, 'JPEG', 0, 0, _this.imgWidth, _this.imgHeight)
          if (j < _this.pageCount) {
            pdf.addPage()
          }
          _this.createPdf(j + 1)
        })
      },
      goreport() {
        let routeData = this.$router.resolve({
          name: 'desktop'
        });
        window.open(routeData.href, '_blank');
      },

      last() {
        var container = document.querySelector('#content');
        var top = container.scrollTop
        var page = parseInt(top / 1279) - 1
        container.scrollTop = 1279.14 * page + 0.5;
      },
      next() {
        var container = document.querySelector('#content');
        var top = container.scrollTop
        var page = parseInt(top / 1279) + 1
        container.scrollTop = 1279.14 * page + 0.5;
      },
    }
  }

</script>
<style scoped>
  html,
  body {
    width: 100%;
    height: 100%;
  }

  div::-webkit-scrollbar {
    width: 0;
  }

  body::-webkit-scrollbar {
    width: 0;
  }


  .btnList {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: fixed;
    flex-direction: column;
    right: 70px;
    top: 50%;
    transform: translateY(-50%);
  }

  .btn {
    background-color: rgba(255, 255, 255, 0.25);
    color: rgba(255, 255, 255, 0.7);
    background-color: rgba(255, 255, 255, 0.25);
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    padding: 5px 20px;
    width: 70px;
    border-radius: 2px;
    text-align: center;
  }

  #content {
    /* width: 400px;
  height: 568.5px; */
    width: 900px;
    height: 1279.14px;
    overflow-y: hidden;
    margin: auto;
    background-color: cadetblue;
  }

  .pdfDom {
    /* height: 568.5px;
  width: 400px; */
    /* width: 440px;
  height: 625.35px; */
    width: 900px;
    height: 1279.14px;
    margin: auto;
    box-sizing: border-box;
    position: relative;
  }

  .pdfPage {
    /* height: 568.5px;
  width: 400px; */
    width: 900px;
    height: 1279.14px;
    background-color: #fff;
    box-sizing: border-box;
    position: relative;

  }

  .fenpuTitle {
    font-weight: bold;
    font-size: 24px;
    text-align: center;
  }

  .chartScoreDiv {
    font-size: 20px;
    text-align: center;
    padding-top: 30px;
  }

  .indexInfoDiv {
    text-align: center;
  }

  .chartTitle {
    font-size: 18px;
    padding-top: 20px;
    padding-left: 40px;
  }
  .chartDesc {
    font-size: 13px;
    padding-left: 80px;
  }

  

  .box {
    display: flex;
    flex-wrap: wrap;
    /* align-content: space-between; */
  }

  .column {
    width: 50%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    /* justify-content: space-between; */

  }

  .eboard {
    width: 90%;
  }

  .board {
    width: 45%;
  }

  .menu {
    display: flex;
    justify-content: space-between;
    padding-left: 5px;
    font-size: 12px;
  }

  .menuDiv {
    display: flex;
    flex-direction: column;
    height: 600px;
    justify-content: space-around;
  }
  table tr td {
    padding: 3px 0px 3px 10px;
  }
</style>